var _metadata, _defs, _sodipodiNamedview, _path, _g, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfusedDog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    width: 94,
    height: 81,
    viewBox: "0 0 94 81",
    fill: "none",
    id: "svg24",
    sodipodiDocname: "confused-dog.svg",
    inkscapeVersion: "1.0.1 (3bc2e813f5, 2020-09-07)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata30"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs28"
  })), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    objecttolerance: 10,
    gridtolerance: 10,
    guidetolerance: 10,
    inkscapePageopacity: 0,
    inkscapePageshadow: 2,
    "inkscapeWindow-width": 1920,
    "inkscapeWindow-height": 1017,
    id: "namedview26",
    showgrid: "false",
    inkscapeZoom: 10.493827,
    inkscapeCx: 63.367807,
    inkscapeCy: 49.974189,
    "inkscapeWindow-x": 1912,
    "inkscapeWindow-y": -8,
    "inkscapeWindow-maximized": 1,
    "inkscapeCurrent-layer": "svg24",
    "inkscapeDocument-rotation": 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70 58H66V74H69V72H76V68H70V58Z",
    fill: "black",
    id: "path10"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g873"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55 30V37H52V44H49V54H45V61H42V64H39V74H22V77H18V81H39V78H45V81H59V78H48V74V71H52V67H55H59V61H62V50H59V40V30H55Z",
    fill: "black",
    id: "path8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62 26H59V21H57V12H59V7H62V3V0H66V3H69V5V7H74H79V9H84V10H92V13H89V17H86V20H83V27H86V36H83V40H79V33H76V26H72V23H62V26ZM64 12H66V14H64V12ZM78 12H76V14H78V12Z",
    fill: "black",
    id: "path12"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g864"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 81H8V78H12V74H15V71H25V74H22V78H18V81Z",
    fill: "#CDCDCD",
    id: "path2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 26V50H62V58H70V68H76V81H86V78H83V74H79V58H83V40H79V33H76V26H72V23H62V26H59Z",
    fill: "#CDCDCD",
    id: "path4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 78V81H59V78H48V71H52V67H59V61H62V58H66V76H68V78H70Z",
    fill: "#CDCDCD",
    id: "path6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69 17V10H73V17H76V20H72V18H70V20H66V17H69Z",
    fill: "#CDCDCD",
    id: "path14"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g898"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 78,
    width: 6,
    height: 3,
    fill: "white",
    id: "rect20"
  })), /*#__PURE__*/React.createElement("rect", {
    y: 74,
    width: 8,
    height: 7,
    fill: "#ffffff",
    id: "rect16",
    x: 0,
    style: {
      strokeWidth: 1.52753
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 74,
    width: 8,
    height: 7,
    fill: "#ffffff",
    id: "rect18",
    style: {
      strokeWidth: 1.52753
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 78,
    width: 6,
    height: 3,
    fill: "#ffffff",
    id: "rect22"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 76,
    width: 7.9999995,
    height: 1.9999983,
    fill: "#ffffff",
    id: "rect20-0",
    style: {
      strokeWidth: 0.942809
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 74,
    width: 4,
    height: 4,
    fill: "#ffffff",
    id: "rect16-2",
    x: 8,
    style: {
      strokeWidth: 0.816499
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 74,
    width: 3,
    height: 4,
    fill: "#ffffff",
    id: "rect18-8",
    style: {
      strokeWidth: 0.707106
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfusedDog);
export default __webpack_public_path__ + "static/media/confused-dog.526fb2fd090f6d3b955735b76576a172.svg";
export { ForwardRef as ReactComponent };